import { openDB } from "idb";

const DB_NAME = "RasamDB";
const STORE_NAME = "dashboard";
const Version=1;

export async function initDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
}
export async function setSetting(key, value) {
  const db = await initDB();
  return db.put(STORE_NAME, value, key);
}
export async function getSetting(key) {
  const db = await initDB();
  return db.get(STORE_NAME, key);
}
export async function deleteSetting(key) {
  const db = await initDB();
  return db.delete(STORE_NAME, key);
}
